import useTranslation from 'next-translate/useTranslation';

import { Translate } from '@core/constant';

import { Typography } from '../typography';
import { TableItemsQuantityProps } from './interface-table';

export const TableItemsQuantity = ({ quantity, ...restProps }: TableItemsQuantityProps) => {
  const { t: tTable } = useTranslation(Translate.common.TABLE);
  return (
    <Typography {...restProps}>{`${quantity} ${
      quantity > 1 ? tTable('items') : tTable('item')
    }`}</Typography>
  );
};
